export default {
  cashFlow: []
}
